export default {
  cashFlow: []
}
